import '../dist/templates/clipping/clipboards-dropdown-list-item';

(function(exports) {
  var MIN_ITEMS_TO_SHOW_SEARCH = 4;

  var $ = exports.$,
      ss = exports.slideshare_object,
      utils = ss.utils,
      hasFoundation = !!$.fn.foundation,
      jSecure = exports.jSecure;

  var classes = {
    clipboardItem: 'j-clipboard j-clipboard-item',
    searchHighlight: 'search-highlight',
    bulk: 'bulk'
  };

  var keys = {
    enter: 13
  };

  var selectors = {
    searchInput: '.j-clips-search',
    createForm: '.j-create-form',
    createFormError: '.j-create-form-error',
    createFormInput: '.j-create-form-input',
    createFormWrapper: '.j-create-form-wrapper',
    clipboardItem: '.j-clipboard-item',
    clipboardList: '.j-clipboard-names-dropdown',
    createNew: '.j-create-new',
    dropdown: '#clipboard-names-dropdown'
  };

  var templates = {
    listItem: 'templates.clipping.clipboards-dropdown-list-item'
  };

  var attr = {
    clipboard: 'clipboard-to'
  };

  var events = {
    clipboardSelected: 'clipboard:selected',
    clipboardCreated: 'clipboard:created',
    bulkClipboardSelected: 'clipboard:selected:bulk',
    bulkClipboardCreated: 'clipboard:created:bulk'
  };

  /**
   * Sorts the clipboards by the query match.
   * @param {String} query The query
   * @param {String} a The first item being compared
   * @param {String} b The second item being compared
   * @returns {Number}
   */
  function sortClipboardsByQueryMatch(query, a, b) {
    var aClipboard = $(a).data(attr.clipboard),
        bClipboard = $(b).data(attr.clipboard),
        aTitle = aClipboard.title.toLowerCase(),
        bTitle = bClipboard.title.toLowerCase(),
        aIndex = aTitle.indexOf(query),
        bIndex = bTitle.indexOf(query);

    if (aIndex !== bIndex) {
      return aIndex - bIndex;
    }

    if (aTitle < bTitle) {
      return -1;
    }

    if (aTitle > bTitle) {
      return 1;
    }

    return 0;
  }

  /**
   * Creates a clipboard title
   * @param {Object} clipboard The clipboard object
   * @param {String} title An optional title
   * @returns {String}
   */
  function makeClipboardTitle(clipboard, title) {
    title = title || clipboard.title;
    return title;
  }

  /**
   * Creates an element to be used as a title for the searched items
   * @param {Object} clipboard The current clipboard
   * @param {String} query The search query
   * @returns {String} The title
   */
  function makeSearchTitle(clipboard, query) {
    var title = clipboard.title,
        index = title.toLowerCase().indexOf(query);
    return makeClipboardTitle(
      clipboard,
      jSecure.processTemplate(
        '{prefix}<span class="{searchHighlight}">{mid}</span>{suffix}',
        {
          prefix: title.substring(0, index),
          mid: title.substring(index, index + query.length),
          suffix: title.substring(index + query.length),
          searchHighlight: classes.searchHighlight
        }
      )
    );
  }

  /**
   * Object that handles user interactions on the clipboards dropdown.
   */
  function ClipboardsDropdown() {
    this._$events = $({});
    this.api = utils.imports('clips.api');

    this.$el = $(selectors.dropdown);
    this.$clipboardList = this.$el.find(selectors.clipboardList);
    this.$searchInput = this.$el.find(selectors.searchInput);
    this.$createNew = this.$el.find(selectors.createNew);
    this.$createFormWrapper = this.$el.find(selectors.createFormWrapper);
    this.$createForm = this.$createFormWrapper.find(selectors.createForm);
    this.$createFormInput = this.$createFormWrapper.find(selectors.createFormInput);
    this.$createFormError = this.$createFormWrapper.find(selectors.createFormError);
    this.itemTemplate = utils.imports(templates.listItem);

    this.attachEventListeners();
  }

  /**
   * Binds all necessary events
   */
  ClipboardsDropdown.prototype.attachEventListeners = function() {
    this.$el.on('input', selectors.searchInput, this.onSearchClipboards.bind(this));
    this.$el.on('input', selectors.searchInput, this.clearCreateFormError.bind(this));
    this.$el.on('input', selectors.createFormInput, this.clearCreateFormError.bind(this));
    this.$el.on('keypress', selectors.searchInput, this.onSearchKeypress.bind(this));
    this.$el.on('click', selectors.createNew, this.showCreateInput.bind(this));
    this.$el.on('submit', selectors.createForm, this.onCreateFormSubmit.bind(this));
    this.$el.on('click', selectors.clipboardItem, this.onClipboardClick.bind(this));
  };

  /**
   * Creates a clipboard via the server api's
   * @param {Object} e The event object
   */
  ClipboardsDropdown.prototype.onCreateFormSubmit = function(e) {
    e.preventDefault();

    this.clearCreateFormError();
    this.api
      .createClipboard({
        title: this.$createFormInput.val()
      })
      .then(
        this.onCreateClipboardSuccess.bind(this),
        this.onCreateClipboardFailure.bind(this));
  };

  /**
   * Triggers a clipboard created event and closes the dropdown on create clipboard success
   * @param {Object} clipboard The created clipboard
   */
  ClipboardsDropdown.prototype.onCreateClipboardSuccess = function(data) {
    var event = this.isBulk() ? events.bulkClipboardCreated : events.clipboardCreated
    this._$events.trigger(event, data);

    //Triggers event to track clipboard created
    $(document).trigger(events.clipboardCreated, data);

    this.close();
  };

  /**
   * Show an error message on create clipboard failure
   * @param {Object} xhr
   */
  ClipboardsDropdown.prototype.onCreateClipboardFailure = function(xhr) {
    this.setCreateFormError('Name ' + xhr.responseJSON.errors.title[0]);
  };

  /**
   * Triggers a selected clipboard event and closes the dropdown
   * @param {Object} e The event object
   */
  ClipboardsDropdown.prototype.onClipboardClick = function(e) {
    var $clipboard = $(e.currentTarget),
        clipboard = $clipboard.data(attr.clipboard);

    if (clipboard) {
      var event = this.isBulk() ? events.bulkClipboardSelected : events.clipboardSelected
      this._$events.trigger(event, clipboard);
      this.close();
    }
  };

  /**
   * Filters the clipboards dropdown based on the value in the search input
   * @param {Object} e The event object
   */
  ClipboardsDropdown.prototype.onSearchClipboards = function(e) {
    var $target = $(e.target),
        query = $target.val().toLowerCase(),
        $clipboards = $(selectors.clipboardItem);

    $clipboards.hide();
    $clipboards.detach();
    $clipboards.sort(function(a, b) {
      return sortClipboardsByQueryMatch(query, a, b);
    });

    $clipboards.appendTo(this.$clipboardList);
    $clipboards.each(function(index, clipboard) {
      var $clipboard = $(clipboard),
          $button = $clipboard.find('button'),
          data = $clipboard.data(attr.clipboard),
          title = data.title;

      if (title.toLowerCase().indexOf(query) > -1) {
        $button.html(makeSearchTitle(data, query));
        $clipboard.show();
      }
    });

    this.scrollToTop();
  };

  /**
   * Selects the first clipboard on enter
   * @param {Object} e The event object
   */
  ClipboardsDropdown.prototype.onSearchKeypress = function(e) {
    if (e.which !== keys.enter) {
      return;
    }

    var $clipboards = $(selectors.clipboardItem + ':visible'),
        $first = $clipboards.first(),
        clipboard = $first.data(attr.clipboard);

    if (clipboard) {
      if (clipboard.is_default) {
        this.close();
      } else {
        this._$events.trigger(events.clipboardSelected, clipboard);
      }
    }
  };

  /**
   * Shows the create clipboard input
   */
  ClipboardsDropdown.prototype.showCreateInput = function() {
    this.$createNew.hide();
    this.$createForm.show();
    this.$createFormInput.val('').focus();
  };

  /**
   * Sets the create form errors
   * @param {String} message The error message
   */
  ClipboardsDropdown.prototype.setCreateFormError = function(message) {
    var hasError = Boolean(message);
    this.$createFormWrapper.toggleClass('error', hasError);
    this.$createFormError
      .text(message || '')
      .toggleClass('hide', !hasError);
  };

  /**
   * Clears the create form errors
   */
  ClipboardsDropdown.prototype.clearCreateFormError = function() {
    this.setCreateFormError();
  };

  /**
   * Sets an event handler for a given event type.
   * @param {string} event The event type to listen for.
   * @param {function} handler The method to invoke.
   */
  ClipboardsDropdown.prototype.on = function(event, handler) {
    this._$events.on(event, handler);
  };

  /**
   * Populates the dropdown with the given clipboards
   * @param {Array} clipboards The clipboard list
   */
  ClipboardsDropdown.prototype.updateClipboards = function(clipboards) {
    var list = clipboards.map(
      function (clipboard) {
        clipboard.checkVisibility = clipboard.checked ? 'show' : 'hide';
        var itemTempl = this.itemTemplate(clipboard);
        return $(itemTempl).data(attr.clipboard, clipboard);
      }.bind(this)
    );

    this.$clipboardList.empty();
    list.forEach(item => this.$clipboardList.append(item))
  };

  /**
   * Updates the search input. The search input will only show if there
   * are enough items in the clipboard list.
   * @param {Array} clipboards The clipboard list
   */
  ClipboardsDropdown.prototype.updateSearchInput = function(clipboards) {
    var useSearch = clipboards.length > MIN_ITEMS_TO_SHOW_SEARCH;
    this.$clipboardList.toggleClass('has-search', useSearch);
    this.$searchInput.toggle(useSearch);
    this.$searchInput.val('');
  };

  /**
   * Updates the create new button
   */
  ClipboardsDropdown.prototype.updateCreateNew = function() {
    this.clearCreateFormError();
    this.$createNew.show();
    this.$createForm.hide();
  };

  /**
   * Updates the clipboards dropdown with the given list of clipboards
   * @param {Array} clipboards The clipboards list
   */
  ClipboardsDropdown.prototype.update = function(clipboards) {
    this.updateClipboards(clipboards);
    this.updateSearchInput(clipboards);
    this.updateCreateNew();
    this.scrollToTop();
  };

  /**
   * Closes the dropdown
   */
  ClipboardsDropdown.prototype.close = function() {
    if (hasFoundation) {
      $(document).foundation('dropdown', 'close', this.$el);
    }
  };

  /**
   * Scrolls the clipboard list to the top
   */
  ClipboardsDropdown.prototype.scrollToTop = function() {
    this.$clipboardList.scrollTop(0);
  };

  /**
   * Returns whether the dropdown is in 'bulk' mode or not
   */
  ClipboardsDropdown.prototype.isBulk = function() {
    return this.$clipboardList.hasClass(classes.bulk);
  }

  utils.exports('clips.ClipboardsDropdown', ClipboardsDropdown);
}(window));
